export const lang = {
	//titleชื่อเรื่องสําหรับแต่ละหน้า
	title: 'แก้ไขที่อยู่สําหรับจัดส่ง',
}
